import React from "react";
import { Space } from "antd";
import { AxRating, AxDivider, AxButton } from "@dynata/axiom3";

class Rating extends React.Component {
  render() {
    return (
      <div className="section" id="rating">
        <h3>Rating</h3>
        <p>Simple rating component.</p>
        <AxDivider orientation="left" plain>
          Basic Usage
        </AxDivider>
        <Space direction="vertical">
          <Space size="large" direction="vertical">
            <pre>{`<AxRating character={<AxIconWrapper type="solid" size="20" icon={"fa-star"} />}/>`}</pre>
            <div className="prop-header">
              <p className="props-title">Props</p>
              <p>
                For AntD props, visit{" "}
                <AxButton
                  size="small"
                  type="link"
                  target="_blank"
                  href="https://ant.design/components/rate/#API"
                >
                  https://ant.design/components/rate/#API
                </AxButton>
              </p>
            </div>

            <table className="props-table">
              <thead>
                <tr>
                  <th>Property</th>
                  <th>Description</th>
                  <th>type</th>
                  <th>Default</th>
                  <th>Version</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>size</td>
                  <td>The size of the Rating</td>
                  <td>small | large | medium</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>character</td>
                  <td>FontAwesome icon</td>
                  <td>
                    <code>{`<i className="fa-solid fa-star"></i>`}</code>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>allowClear</td>
                  <td>Whether to allow clear when click again</td>
                  <td>boolean</td>
                  <td>true</td>
                  <td></td>
                </tr>
                <tr>
                  <td>allowHalf</td>
                  <td>Whether to allow semi selection</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>autoFocus</td>
                  <td>If get focus when component mounted</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>className</td>
                  <td>The custom class name of rate</td>
                  <td>string</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>count</td>
                  <td>Star count</td>
                  <td>number</td>
                  <td>5</td>
                  <td></td>
                </tr>
                <tr>
                  <td>defaultValue</td>
                  <td>The default value</td>
                  <td>number</td>
                  <td>0</td>
                  <td></td>
                </tr>
                <tr>
                  <td>disabled</td>
                  <td>If read only, unable to interact</td>
                  <td>boolean</td>
                  <td>false</td>
                  <td></td>
                </tr>
                <tr>
                  <td>style</td>
                  <td>The custom style object of rate</td>
                  <td>CSSProperties</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>tooltips</td>
                  <td>Customize tooltip by each character</td>
                  <td>string[]</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>value</td>
                  <td>The current value</td>
                  <td>number</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onBlur</td>
                  <td>Callback when component lose focus</td>
                  <td>function()</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onChange</td>
                  <td>Callback when select value</td>
                  <td>function(value: number)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onFocus</td>
                  <td>Callback when component get focus</td>
                  <td>function()</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onHoverChange</td>
                  <td>Callback when hover item</td>
                  <td>function(value: number)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>onKeyDown</td>
                  <td>Callback when keydown on component</td>
                  <td>function(event)</td>
                  <td>-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>...others</td>
                  <td>
                    All extra props are passed down to the{" "}
                    <>
                      <AxButton
                        size="small"
                        type="link"
                        target="_blank"
                        href="https://4x.ant.design/components/rate/#API"
                      >
                        {`<Rate />`}
                      </AxButton>
                    </>{" "}
                    component.
                  </td>
                  <td></td>
                  <td>-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <pre>{`<AxRating
  size="medium"
  character={<i className="fa-solid fa-star"></i>}
  allowHalf
/>`}</pre>
          </Space>
        </Space>

        <AxDivider orientation="left" plain>
          Default
        </AxDivider>

        <Space direction="vertical" size={24}>
          <AxRating
            size="small"
            character={<i className="fa-solid fa-star"></i>}
            allowHalf
          />

          <AxRating
            size="medium"
            character={<i className="fa-solid fa-star"></i>}
            allowHalf
          />

          <AxRating
            size="large"
            character={<i className="fa-solid fa-star"></i>}
            allowHalf
          />
        </Space>
      </div>
    );
  }
}
export default Rating;
